import { render, staticRenderFns } from "./InfocardCollectorPicker.vue?vue&type=template&id=2fce7d62&"
import script from "./InfocardCollectorPicker.vue?vue&type=script&lang=js&"
export * from "./InfocardCollectorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports